// components/ImageUploadSection.js
import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import ImageUploadField from './ImageUploadField';
import { IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";

const ImageUploadSection = ({ imageFiles, setImageFiles, newImages, setNewImages }) => {
  const [maxImages, setMaxImages] = useState(0);

  useEffect(() => {
    const fetchMaxImages = async () => {
      try {
        const res = await axiosInstance.get(`/product/max-images`);
        setMaxImages(res.data.maxImages);
      } catch (err) {
        console.error('Failed to fetch max images', err);
        setMaxImages(3); // デフォルト値
      }
    };
    fetchMaxImages();
  }, []);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFiles(prev => {
      const updated = [...prev];

      const current = updated[index] || {};

      updated[index] = {
        ...current,
        file,
        willDelete: false,
        isExisting: !!current.image_id,
        replacedImageId: current.image_id ?? null,
      };

      return updated;
    });
  };

  const handleRemoveImage = (index) => {
    setImageFiles(prev => {
      const updated = [...prev];
      const item = updated[index];

      if (!item) return updated;

      if (item.image_id) {
        updated[index] = { ...item, willDelete: true };
      } else {
        updated.splice(index, 1);
      }

      return updated;
    });
  };

  if (!maxImages) return <div>Loading...</div>;
  const filesToDisplay = [...imageFiles];
  while (filesToDisplay.length < maxImages) filesToDisplay.push(null);

  return (
    <div className="product-images">
      {filesToDisplay.map((imageFile, index) => (
        <ImageUploadField
          key={index}
          imageFile={imageFile}
          onChange={e => handleImageChange(e, index)}
          onRemove={() => handleRemoveImage(index)}
          size={200}
        />
      ))}
    </div>
  );
};

export default ImageUploadSection;
